// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".otp{max-width:40px!important;height:40px!important;padding:5px!important;margin:0 10px!important;font-size:20px!important;border-radius:4px!important;border:1px solid rgba(0,0,0,.3)!important;text-align:center!important}input::-moz-placeholder{font-size:15px;text-align:center;font-weight:600}input::placeholder{font-size:15px;text-align:center;font-weight:600}", ""]);
// Exports
module.exports = exports;
